import {
  IDefenseCreateProps,
  IDefenseProps,
  IDefenseUpdateParams,
} from './types';
import { api } from '../../DefaultService';

const ENDPOINT = 'v1/integrations/defense';

export const createDefenseIntegrationAsync = async (
  data: IDefenseCreateProps,
): Promise<IDefenseProps> => {
  return await api
    .post(ENDPOINT, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateDefenseIntegrationAsync = async ({
  id,
  data,
}: IDefenseUpdateParams): Promise<IDefenseProps> => {
  return await api
    .put(`${ENDPOINT}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteDefenseIntegrationAsync = async (
  id: number,
): Promise<void> => {
  await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};

export const getDefenseIntegrationByIdAsync = async (
  id: number,
): Promise<IDefenseProps> => {
  return await api
    .get(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};
